import cn from 'classnames';
import React, { memo } from 'react';

import { Link } from 'components';
import { Row } from 'components/layout';
import CardLogo from 'components/candidate/CardLogo';

import styles from './SocietyCard.module.scss';

export interface SocietyCardProps {
  id: string;
  name: string;
  icon_url: string;
  is_verified: boolean;
  huzzle_verified: boolean;
  university: string;
  url: string;
}

export const SocietyCard: React.FC<SocietyCardProps> = memo(
  ({
    name,
    icon_url,
    is_verified,
    huzzle_verified,
    university,
    url,
  }: SocietyCardProps) => {
    const contentClassNames = cn({
      [styles.SocietyCard]: true,
    });

    return (
      <Link
        href={url}
        underlineOnHover={false}
        className={styles.link}
        target="_blank"
      >
        <div className={contentClassNames} data-testid="SocietyCard">
          <CardLogo
            is_verified={is_verified}
            huzzle_verified={huzzle_verified}
            logo_url={icon_url}
            initials={name.substring(0, 1).toUpperCase()}
            size={'large'}
            className={styles.logo}
            verifiedClassName={styles.icon}
            cohostsLogoDetails={null}
          />

          <div>
            <p className={styles.title}>{name}</p>
            <Row className={styles.detailRow}>
              <div>{university}</div>
            </Row>
          </div>
        </div>
      </Link>
    );
  }
);

SocietyCard.displayName = 'SocietyCard';
